/**
 * @generated SignedSource<<66e865048909ee09d637bf1eff59f1db>>
 * @relayHash 5cf2023e9b8c29981317d0c96358c120
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 47309ef4f0528596aad5fd12bb920206161b8158dfc724a937b0d87303f6248d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import isBusinessStatusMappingEnabled_provider from '@atlassian/jira-relay-provider/src/allow-status-mapping-on-business-board.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "47309ef4f0528596aad5fd12bb920206161b8158dfc724a937b0d87303f6248d",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": isBusinessStatusMappingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
